import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreditCardComponent } from '../../projects/credit-card/src/lib/credit-card.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  form!: FormGroup;
  formCustomCard!: FormGroup;

  // Credit Card Normal
  @ViewChild('creditCardComponent', { static: true })
  creditCardComponent!: CreditCardComponent

  @ViewChild('creditCardNumberRef', { static: true })
  creditCardNumberRef!: ElementRef;

  @ViewChild('creditCardPersonNameRef', { static: true })
  creditCardPersonNameRef!: ElementRef;

  @ViewChild('creditCardDateValidRef', { static: true })
  creditCardDateValidRef!: ElementRef;

  @ViewChild('creditCardCVC', { static: true })
  creditCardCVC!: ElementRef;


  // Custom Credit Card
  @ViewChild('customCreditCardComponentRef', { static: true })
  customCreditCardComponent!: CreditCardComponent

  @ViewChild('inputNumberRef', { static: true })
  customCreditCardNumberRef!: ElementRef;

  @ViewChild('inputNameRef', { static: true })
  customCreditCardPersonNameRef!: ElementRef;

  @ViewChild('inputValidDateRef', { static: true })
  customCreditCardDateValidRef!: ElementRef;

  @ViewChild('inputCVCRef', { static: true })
  customCreditCVCRef!: ElementRef;

  constructor() { }

  ngOnInit(): void {

    this.form = new FormGroup({
      cardNumber: new FormControl('378282246310005', Validators.required),
      cardPersonName: new FormControl('Juan Perez', Validators.required),
      validDate: new FormControl('10/20', Validators.required),
      cvc: new FormControl('123', Validators.required)
    })

    this.formCustomCard = new FormGroup({
      cardNumber: new FormControl('4120 0311 4390 2092', Validators.required),
      cardPersonName: new FormControl('Oscar Del Rio', Validators.required),
      validDate: new FormControl('', Validators.required),
      cvc: new FormControl('', Validators.required),
      labelInitialCardNumber: new FormControl(''),
      labelInitialDateValid: new FormControl(''),
      labelInitialPersonName: new FormControl(''),
      labelTextLabelMonthYear: new FormControl(''),
      labelValidUntilText: new FormControl(''),
      labelInitialCVC: new FormControl(''),
      labelTextFooter: new FormControl('')
    });


    // Credit Card Normal
    this.creditCardComponent.creditCardNumberInputRef = this.creditCardNumberRef;
    this.creditCardComponent.creditCardDateValidInputRef = this.creditCardDateValidRef;
    this.creditCardComponent.creditCardPersonNameInputRef = this.creditCardPersonNameRef;
    this.creditCardComponent.creditCardCVCInputRef = this.creditCardCVC;

    // Custom Credit Card
    this.customCreditCardComponent.creditCardNumberInputRef = this.customCreditCardNumberRef;
    this.customCreditCardComponent.creditCardDateValidInputRef = this.customCreditCardDateValidRef;
    this.customCreditCardComponent.creditCardPersonNameInputRef = this.customCreditCardPersonNameRef;
    this.customCreditCardComponent.creditCardCVCInputRef = this.customCreditCVCRef;
  }

  get labelInitialCardNumber() {
    return this.formCustomCard.get('labelInitialCardNumber');
  }

  get labelInitialDateValid() {
    return this.formCustomCard.get('labelInitialDateValid');
  }

  get labelInitialPersonName() {
    return this.formCustomCard.get('labelInitialPersonName');
  }

  get labelTextLabelMonthYear() {
    return this.formCustomCard.get('labelTextLabelMonthYear');
  }

  get labelValidUntilText() {
    return this.formCustomCard.get('labelValidUntilText');
  }

  get labelInitialCVC() {
    return this.formCustomCard.get('labelInitialCVC');
  }

  get labelTextFooter() {
    return this.formCustomCard.get('labelTextFooter');
  }

}
